import React, { useEffect, useState } from "react";
import "./Vessels.css";

const vessels = [
  {
    id: "tiger-shark",
    name: "M.V. Tiger Shark",
    type: "Class 230 lift boat",
    image: "/images/photos/vessels/tiger shark/Tiger Shark 1.webp?v=20261003",
    description:
      "A self-elevating work platform configured for shallow offshore wellhead installation, subsea and topside construction, and diving support.",
    more:
      "This SEWOP has the highest lifting capacity of its class in the Gulf of Guinea. It is suited to shallow offshore wellhead platform installation and other subsea and topside construction and installation projects, and also serves as a robust diving support platform.",
    gallery: [
      "/images/photos/vessels/tiger shark/Tiger Shark 3.webp",
      "/images/photos/vessels/tiger shark/Tiger Shark Vessel 1.webp",
      "/images/photos/vessels/tiger shark/Tiger Shark Vessel 2.webp",
      "/images/photos/vessels/tiger shark/WhatsApp Image 2025-09-22 at 10.14.42_2174a8d6.webp",
      "/images/photos/vessels/tiger shark/Bridge.webp",
      "/images/photos/vessels/tiger shark/Deck.webp",
      "/images/photos/vessels/tiger shark/Galley.webp",
      "/images/photos/vessels/tiger shark/Accomodation.webp",
    ],
    specs: [
      ["Platform", "Self-Elevating Work Over Platform (SEWOP)"],
      ["Crane capacity", "150 t and 21.6 t"],
      ["Clear deck space", "4,059 sq ft"],
      ["Capabilities", "Wellhead installation, construction and dive support"],
    ],
  },
  {
    id: "black-jack",
    name: "M.V. Black Jack",
    type: "Class 200 lift boat",
    image: "/images/photos/vessels/black jack/Black Jack Offshore Work Barge.webp",
    description:
      "A multipurpose shallow-water SEWOP with a moon pool for diving support, wellhead platform work and offshore construction.",
    more:
      "Black Jack is equipped with a 71.5 t starboard crane and a 17.1 t portside crane. Its shallow-water work profile supports wellhead platforms and other construction and installation activities.",
    specs: [
      ["Crane capacity", "71.5 t starboard and 17.1 t portside"],
      ["Clear deck space", "3,292 sq ft"],
      ["Water depth capability", "154 ft"],
      ["Capabilities", "Construction and diving support"],
    ],
  },
  {
    id: "ella-conqueror",
    name: "M.V. Ella Conqueror",
    type: "DP2 120 t AHTS",
    image: "/images/photos/vessels/ella conqueror/Ella Conqueror 1.webp",
    description:
      "A DP2 Anchor Handling Tug Supply vessel supporting offshore construction and work around wellhead platforms.",
    more:
      "Ella Conqueror is equipped with two 680 kW CPP tunnel bow thrusters and one 680 kW CPP tunnel stern thruster. It can accommodate 42 persons and supports offshore wellhead platforms and other construction and installation works.",
    gallery: [
      "/images/photos/vessels/ella conqueror/Ella Conqueror 2.webp",
      "/images/photos/vessels/ella conqueror/Ella Conqueror 3.webp",
      "/images/photos/vessels/ella conqueror/Ella Conqueror Vessel 1.webp",
      "/images/photos/vessels/ella conqueror/Ella Conqueror Vessel 2.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0017.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0018.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0019.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0069.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0070.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0071.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0072.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0073.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0074.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0075.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0076.webp",
      "/images/photos/vessels/ella conqueror/IMG-20250922-WA0077.webp",
    ],
    specs: [
      ["Bollard pull", "120 t"],
      ["Clear deck space", "480 sq m"],
      ["Accommodation", "42 persons"],
      ["Thrusters", "2 x 680 kW bow; 1 x 680 kW stern"],
    ],
  },
  {
    id: "david-runner",
    name: "M.V. David Runner",
    type: "DP2 160 ft fast supply vessel",
    image: "/images/photos/vessels/david runner/David Runner 1 (1).webp",
    description:
      "A high-speed DP2 Fast Supply Vessel built for efficient delivery and offshore support.",
    more:
      "David Runner is fitted with four CAT main engines producing 7,240 BHP and reaches speeds of 28.5 knots. Its fast-supply configuration is designed for high-speed performance, delivery capability and efficiency.",
    gallery: [
      "/images/photos/vessels/david runner/David Runner 2 (1).webp",
      "/images/photos/vessels/david runner/David Runner 3 (1).webp",
      "/images/photos/vessels/david runner/David Runner 5.webp",
    ],
    specs: [
      ["Main engines", "4 CAT engines, 7,240 BHP total"],
      ["Speed", "28.5 knots"],
      ["Clear deck area", "106 ft"],
      ["Vessel class", "DP2 Fast Supply Vessel (FSV)"],
    ],
  },
];

const badges = [
  ["04", "Vessels featured"],
  ["28.5", "Knots top speed"],
  ["42", "Persons accommodated"],
];

function Vessels() {
  const [activeVessel, setActiveVessel] = useState(null);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);

  const activePhotos = activeVessel
    ? [activeVessel.image, ...(activeVessel.gallery || [])]
    : [];

  useEffect(() => {
    if (!activeVessel) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setActiveVessel(null);
      }
      if (event.key === "ArrowLeft") {
        setActivePhotoIndex((index) => (index + activePhotos.length - 1) % activePhotos.length);
      }
      if (event.key === "ArrowRight") {
        setActivePhotoIndex((index) => (index + 1) % activePhotos.length);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeVessel, activePhotos.length]);

  const openGallery = (vessel) => {
    setActivePhotoIndex(0);
    setActiveVessel(vessel);
  };

  const showPhoto = (offset) => {
    setActivePhotoIndex((index) => (index + activePhotos.length + offset) % activePhotos.length);
  };

  return (
    <main className="vessels-page">
      <section
        className="vessels-hero"
        style={{ backgroundImage: "url('/images/photos/vessels/tiger shark/Tiger Shark 1.webp?v=20261003')" }}
      >
        <div className="vessels-hero-overlay" />
        <div className="vessels-container vessels-hero-content">
          <span className="vessels-label">Vessels</span>
          <h1>
            Marine capability
            <br />
            <span>ready for the field.</span>
          </h1>
          <p>
            A capable fleet supporting offshore logistics, marine construction,
            subsea works and dependable project delivery.
          </p>
        </div>
      </section>

      <section className="vessels-overview">
        <div className="vessels-container">
          <div className="vessels-badges">
            {badges.map(([value, label]) => (
              <div className="vessel-badge" key={label}>
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            ))}
          </div>

          <div className="vessels-heading">
            <div>
              <span className="vessels-label">Fleet profile</span>
              <h2>
                The right vessel
                <br />
                <span>for every assignment.</span>
              </h2>
            </div>
            <p>
              From shallow-water lift boats to DP2 supply and support vessels,
              the fleet covers construction, diving and offshore delivery work.
            </p>
          </div>

          <div className="vessels-grid">
            {vessels.map((vessel) => (
              <article className="vessel-card" key={vessel.name}>
                <div className="vessel-image-wrap">
                  <img src={vessel.image} alt={vessel.name} />
                </div>
                <div className="vessel-card-content">
                  <span className="vessel-type">{vessel.type}</span>
                  <h3>{vessel.name}</h3>
                  <p>{vessel.description}</p>
                  <dl className="vessel-specs">
                    {vessel.specs.map(([label, value]) => (
                      <div key={label}>
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                      </div>
                    ))}
                  </dl>
                  <button
                    type="button"
                    className="vessel-more-toggle"
                    aria-label={`See more about ${vessel.name}`}
                    onClick={() => openGallery(vessel)}
                  >
                    See more
                    <span aria-hidden="true">↗</span>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {activeVessel && (
        <div
          className="vessel-gallery-backdrop"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setActiveVessel(null);
            }
          }}
        >
          <section
            className="vessel-gallery-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="vessel-gallery-title"
          >
            <button
              type="button"
              className="vessel-gallery-close"
              aria-label="Close vessel gallery"
              onClick={() => setActiveVessel(null)}
            >
              ×
            </button>

            <div className="vessel-gallery-viewer">
              <img
                src={activePhotos[activePhotoIndex]}
                alt={`${activeVessel.name}, view ${activePhotoIndex + 1}`}
              />
              {activePhotos.length > 1 && (
                <>
                  <button
                    type="button"
                    className="vessel-gallery-arrow vessel-gallery-previous"
                    aria-label="Previous photo"
                    onClick={() => showPhoto(-1)}
                  >
                    ‹
                  </button>
                  <button
                    type="button"
                    className="vessel-gallery-arrow vessel-gallery-next"
                    aria-label="Next photo"
                    onClick={() => showPhoto(1)}
                  >
                    ›
                  </button>
                </>
              )}
            </div>

            <div className="vessel-gallery-details">
              <span className="vessel-type">{activeVessel.type}</span>
              <h2 id="vessel-gallery-title">{activeVessel.name}</h2>
              <p>{activeVessel.more}</p>
              <dl className="vessel-specs">
                {activeVessel.specs.map(([label, value]) => (
                  <div key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                  </div>
                ))}
              </dl>
              {activePhotos.length > 1 && (
                <div className="vessel-gallery-thumbnails" aria-label="Vessel photos">
                  {activePhotos.map((image, index) => (
                    <button
                      type="button"
                      key={image}
                      className={index === activePhotoIndex ? "is-active" : ""}
                      aria-label={`Show photo ${index + 1} of ${activeVessel.name}`}
                      aria-pressed={index === activePhotoIndex}
                      onClick={() => setActivePhotoIndex(index)}
                    >
                      <img src={image} alt="" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </main>
  );
}

export default Vessels;
